import * as React from "react";
import { Modal } from "@doordash/component-modal";
import { ModalProps } from "../constants";
import { TextField } from "@doordash/component-fields";

export const AddOrEditMenuHeadingsModal: React.FC<ModalProps> = ({
  primaryActionProps,
  secondaryActionProps,
  setOpenModal,
  fields,
  updateForm,
  onClose,
}) => (
  <Modal
    title={`${fields.menu_heading_name ? "Edit" : "New"} Menu Heading`}
    primaryAction={primaryActionProps}
    secondaryAction={secondaryActionProps}
    onClose={onClose}
    isFullScreenOnMobile
  >
    <TextField
      label={"Menu Heading Name"}
      autoComplete={"off"}
      onChange={(value: string) => updateForm({ menu_heading_name: value })}
      value={fields.menu_heading_name || ""}
    />
  </Modal>
);
